import React from 'react';

import { setIn } from '@lyearn/core/utils/immutable';
import { Select } from '@lyearn/ui';
import { CustomFrequencyEnum } from '@/types/schema';

import { FrequencyComponentProps } from '../../../types';
import { CustomEmailDigestFrequency } from '../conts';

const getOptions = (allowedCustomFrequencies?: CustomFrequencyEnum[]) => {
  if (!allowedCustomFrequencies?.length) {
    return CustomEmailDigestFrequency;
  }

  return CustomEmailDigestFrequency.filter((item) => allowedCustomFrequencies.includes(item.value));
};

const CLASSES = { paper: 'rounded-8 shadow-01 border border-divider my-8 w-[12rem]' };

const CustomFrequencyInput: React.FC<FrequencyComponentProps> = React.memo(
  ({ value, onChange, disabled, allowedCustomFrequencies, size }) => {
    const onFrequencyChange = React.useCallback(
      (nextValue: string) => {
        onChange(setIn(value, ['custom', 'frequency'], nextValue));
      },
      [onChange, value],
    );

    const getOptionLabel = React.useCallback(
      (item: (typeof CustomEmailDigestFrequency)[0]) =>
        (value?.custom?.interval || 0) > 1 ? item.pluralLabel : item.label,
      [value?.custom?.interval],
    );

    const options = getOptions(allowedCustomFrequencies);

    return (
      <Select
        disableClearable
        className="flex flex-1"
        classes={CLASSES}
        disabled={disabled}
        getOptionLabel={getOptionLabel}
        options={options}
        size={size ?? 'large'}
        value={value.custom?.frequency || CustomFrequencyEnum.Day}
        onChange={onFrequencyChange}
      />
    );
  },
);

export default CustomFrequencyInput;
